<template>
    <div class="product-excel-config">
			<div style="padding-bottom: 5px;">
				<el-button class="el-button--primary vam" size="mini" @click="addNewConfigItem()">
					<i class="el-icon-plus">添加</i>
				</el-button>
				<span style="margin-left: 5px;font-size: 13px;color: #F23946;font-weight: bold;"><i class="el-icon-info" style="margin-right: 2px;"></i>配置券商净值导入excel模板，每一列名称与Excel中名称进行对应。</span>
			</div>
			<el-table :data="tableData" border size="small" style="height:450px;">
				<!--<el-table-column type="expand">-->
					<!--<template slot-scope="props">-->
						<!--<el-form label-position="left" inline class="demo-table-expand">-->
							<!--<el-form-item label="商品名称">-->
								<!--<span></span>-->
							<!--</el-form-item>-->
							<!--<el-form-item label="所属店铺">-->
								<!--<span></span>-->
							<!--</el-form-item>-->
							<!--<el-form-item label="商品 ID">-->
								<!--<span></span>-->
							<!--</el-form-item>-->
							<!--<el-form-item label="店铺 ID">-->
								<!--<span></span>-->
							<!--</el-form-item>-->
							<!--<el-form-item label="商品分类">-->
								<!--<span></span>-->
							<!--</el-form-item>-->
							<!--<el-form-item label="店铺地址">-->
								<!--<span></span>-->
							<!--</el-form-item>-->
							<!--<el-form-item label="商品描述">-->
								<!--<span></span>-->
							<!--</el-form-item>-->
						<!--</el-form>-->
					<!--</template>-->
				<!--</el-table-column>-->
				<el-table-column
					label="券商名称"
					prop="securityname">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input :class="{'error':hasError(scope.row.securitynameError)}" size="mini" v-model="scope.row.securityname" placeholder="请输入券商名称"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.securityname}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="产品名称"
					prop="productname">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.productname" placeholder="请输入产品名称"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.productname}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="产品代码"
					prop="productcode">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.productcode" placeholder="请输入产品代码"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.productcode}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="分级名称"
					prop="categoryname">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.categoryname" placeholder="请输入分级名称"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.categoryname}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="分级代码"
					prop="categorycode">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.categorycode" placeholder="请输入分级代码"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.categorycode}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="估值日期"
					prop="valuetime">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.valuetime" placeholder="请输入估值日期"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.valuetime}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="资产份额"
					prop="propertyportion">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.propertyportion" placeholder="请输入资产份额"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.propertyportion}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="资产净值"
					prop="propertynetvalue">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.propertynetvalue" placeholder="请输入资产净值"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.propertynetvalue}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="单位净值"
					prop="netvalue">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.netvalue" placeholder="请输入单位净值"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.netvalue}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="累计单位净值"
					prop="totalnetvalue">
					<template slot-scope="scope">
						<div v-if="scope.row.isEdit == true">
							<el-input size="mini" v-model="scope.row.totalnetvalue" placeholder="请输入累计单位净值"></el-input>
						</div>
						<div v-else style="text-align: center">
							{{scope.row.totalnetvalue}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="90px">
					<template slot-scope="scope">
						<el-tooltip placement="top" popper-class="my-tooltip" :enterable="false" content="编辑" v-if="scope.row.isEdit != true">
							<el-button size="mini" type="warning" icon="el-icon-edit" circle @click.native.prevent="startEditProductConfigItem(scope.$index, tableData)"></el-button>
						</el-tooltip>
						<el-tooltip placement="top" popper-class="my-tooltip" :enterable="false" content="保存"  v-if="scope.row.isEdit == true">
							<el-button size="mini" type="success" icon="el-icon-check" circle @click.native.prevent="saveProductConfigItem(scope.$index, tableData)"></el-button>
						</el-tooltip>
						<el-tooltip placement="top" popper-class="my-tooltip" :enterable="false" content="删除">
							<el-button size="mini"
								class="el-button--primary" icon="el-icon-delete" circle @click.native.prevent="deleteProductConfigItem(scope.$index, tableData)"></el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
		</div>
</template>

<script>
	import config from "../../../config/global.js";
	import axios from "axios";

	var getProductUploadConfigUrl = config.host+"/backend/org/getexcelconfiglist.json";
	var updateProductUploadConfigUrl = config.host+"/backend/org/updateexcelconfig.json";
	var addProductUploadConfigUrl = config.host+"/backend/org/addexcelconfig.json";
	var deleteProductUploadConfigUrl = config.host+"/backend/org/deleteexcelconfig.json";
    export default {
        name: "product-upload-excel-config",
				data:function () {
					return {
						tableData:[],
						loading:false
					}
				},
				mounted:function () {
					this.getProductUploadConfig();
				},
				methods:{
					addNewConfigItem:function () {
						var configItem = {"securityname":"","productname":"","productcode":"","categoryname":"","categorycode":"","valuetime":"","propertyportion":"","propertynetvalue":"","netvalue":"","totalnetvalue":"",id:null,"isEdit":true};
						this.tableData.push(configItem);
					},
					getProductUploadConfig:function () {
						if( this.loading == false ){
							this.loading = true;
							axios({
								method: 'get',
								url:getProductUploadConfigUrl
							}).then((response)=>{
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								if(response.data.result == 1){
									this.$message({
										message: '获取数据成功',
										type: 'success'
									});

									this.tableData = response.data.items;
								}else{
									this.$alert(response.data.emsg, '获取数据失败', {
										confirmButtonText: '确定'
									});
								}
								this.loading = false;
							}).catch((error)=>{
								this.loading = false;
								this.$alert(error.response.statusText, '获取数据失败', {
									confirmButtonText: '确定'
								});
							})
						}
					},
					startEditProductConfigItem:function(index,tableData) {
						var item = tableData[index];
						item.isEdit = true;
						this.$set(this.tableData,index,item);
					},
					saveProductConfigItem:function (index,tableData) {
						var item = tableData[index];
						//先验证
						var validate = this.validateConfigItem(item);
						if(validate == false ){
							this.$message.error('请补充数据后重试');
							this.$set(this.tableData,index,item);
							return;
						}
						if( this.loading == false ){
							this.loading = true;
							var url = null;
							if( item.id == null ){
								url = addProductUploadConfigUrl;
							}else{
								url = updateProductUploadConfigUrl;
							}
							axios({
								method: 'post',
								url:url,
								data:item
							}).then((response)=>{
								this.loading = false;
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								if(response.data.result == 1){
									this.$message({
										message: '添加成功',
										type: 'success'
									});
									this.getProductUploadConfig();
								}else{
									this.$alert(response.data.emsg, '添加失败', {
										confirmButtonText: '确定'
									});
								}
							}).catch((error)=>{
								this.loading = false;
								this.$alert(error.response.statusText, '添加失败', {
									confirmButtonText: '确定'
								});
							})
						}
					},
					deleteProductConfigItem:function (index,tableData) {
						var item = tableData[index];
						if(item.id == null ){
							this.tableData.splice(index,1);
							return;
						}
						this.$confirm('您确定要删除该产品吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						}).then(()=>{
							if( this.loading == false ){
								this.loading = true;
								axios({
									method: 'post',
									url:deleteProductUploadConfigUrl+"?id="+item.id,
									data:{}
								}).then((response)=>{
									this.loading = false;
									var defaultResult = this.responseDefaultHandle(response);
									if(defaultResult == false )
										return;
									if(response.data.result == 1){
										this.$message({
											message: '删除成功',
											type: 'success'
										});
										this.getProductUploadConfig();
									}else{
										this.$alert(response.data.emsg, '删除失败', {
											confirmButtonText: '确定'
										});
									}
								}).catch((error)=>{
									this.loading = false;
									this.$alert(error.response.statusText, '删除失败', {
										confirmButtonText: '确定'
									});
								})
							}
						});
					},
					validateConfigItem:function (item) {
						var validate = true;
						if(item.securityname == ""){
							item.securitynameError = "券商名称不能为空";
							validate = false;
						}else{
							item.securitynameError = "";
						}
						// if(item.productname == ""){
						// 	item.productnameError = "产品名称不能为空";
						// 	validate = false;
						// }else{
						// 	item.productnameError = "";
						// }
						// if(item.productcode == ""){
						// 	item.productcodeError = "产品编号不能为空";
						// 	validate = false;
						// }else{
						// 	item.productcodeError = "";
						// }
						// if(item.categoryname == ""){
						// 	item.categorynameError = "分类名称不能为空";
						// 	validate = false;
						// }else{
						// 	item.categorynameError = "";
						// }
						// if(item.categorycode == ""){
						// 	item.categorycodeError = "分类代码不能为空";
						// 	validate = false;
						// }else{
						// 	item.categorycodeError = "";
						// }
						// if(item.valuetime == ""){
						// 	item.valuetimeError = "估值日期不能为空";
						// 	validate = false;
						// }else{
						// 	item.valuetimeError = "";
						// }
						// if(item.propertyportion == ""){
						// 	item.propertyportionError = "资产份额不能为空";
						// 	validate = false;
						// }else{
						// 	item.propertyportionError = "";
						// }
						// if(item.propertynetvalue == ""){
						// 	item.propertynetvalueError = "资产净值不能为空";
						// 	validate = false;
						// }else{
						// 	item.propertynetvalueError = "";
						// }
						// if(item.netvalue == ""){
						// 	item.netvalueError = "净值不能为空";
						// 	validate = false;
						// }else{
						// 	item.netvalueError = "";
						// }
						// if(item.totalnetvalue == ""){
						// 	item.totalnetvalueError = "累计净值不能为空";
						// 	validate = false;
						// }else{
						// 	item.totalnetvalueError = "";
						// }
						return validate;
					},
					hasError:function (propertyErrorStr) {
						if(propertyErrorStr == null || propertyErrorStr == ''){
							return false;
						}else {
							return true;
						}
					}
				}
    }
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
	}
	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}
	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.product-excel-config>>>.el-input__inner{
		padding: 0 2px;
	}

	.product-excel-config>>>.el-table .cell{
		padding: 0 5px;
	}

	.product-excel-config>>>.el-table__header .cell{
		text-align: center;
	}

	.product-excel-config>>>.error .el-input__inner{
		border: 1px solid red !important;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/product/ProductUploadExcelConfig.vue